export default "__VITE_ASSET__1lUU_a2b__"